import { render } from "./ProgressiveLimits.vue?vue&type=template&id=7f107bf8&scoped=true"
import script from "./ProgressiveLimits.vue?vue&type=script&lang=js"
export * from "./ProgressiveLimits.vue?vue&type=script&lang=js"

import "./ProgressiveLimits.vue?vue&type=style&index=0&id=7f107bf8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f107bf8"]])

export default __exports__